import { render } from "./AboutPthPrizren.vue?vue&type=template&id=e305b6e4&scoped=true"
import script from "./AboutPthPrizren.vue?vue&type=script&lang=js"
export * from "./AboutPthPrizren.vue?vue&type=script&lang=js"

import "./AboutPthPrizren.vue?vue&type=style&index=0&id=e305b6e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e305b6e4"]])

export default __exports__